import { atom } from "jotai"

export const INIT_DEPARTMENT = {
    deptId: null,
    deptCode: "",
    deptName: "",
    orgId: null,
    orgName: "",
    divId:null,
    divName:"",
    status: ""
}

export const departmentAtom  = atom(INIT_DEPARTMENT)
